import { useMemo } from "react";
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router";

import { MenuItems } from "common";
import Sidebar from "components/Sidebar";
import Page from "components/wrappers/Page";
import { PermittedRoute } from "hooks/useRouter";

import { Account } from "./Account";
import { Designs } from "./Designs";
import DraftCustomPanels from "./DraftCustomPanels";
import { Preferences } from "./Preferences";
import { Quotes } from "./Quotes";
import { UserDetail } from "./UserDetail";
import { Users } from "./Users";

export const Dashboard = () => {
  const match = useRouteMatch();
  const { pathname } = useLocation();

  // Hide sidebar on some specific pages
  const hideSidebar = useMemo(() => {
    if (
      pathname.indexOf("/dashboard/draft-custom-panels") === 0 &&
      (pathname.includes("view") || pathname.includes("edit"))
    ) {
      return true;
    }
    return false;
  }, [pathname]);

  return (
    <Page withoutContainer={hideSidebar}>
      {!hideSidebar && <Sidebar />}
      <Switch>
        <Route exact path={`${match.url}/account`} component={Account} />
        <Route
          exact
          path={`${match.url}/preferences`}
          component={Preferences}
        />
        <Route exact path={`${match.url}/quotes`} component={Quotes} />
        <Route exact path={`${match.url}/users/:id`} component={UserDetail} />
        <Route
          path={`${match.url}/draft-custom-panels`}
          component={DraftCustomPanels}
        />

        <PermittedRoute
          exact
          permissions={
            MenuItems.find((menuItem) => menuItem.link === `${match.url}/users`)
              ?.validRoles || []
          }
          path={`${match.url}/users`}
          component={Users}
        />
        <PermittedRoute
          exact
          permissions={
            MenuItems.find(
              (menuItem) => menuItem.link === `${match.url}/designs`
            )?.validRoles || []
          }
          path={`${match.url}/designs`}
          component={Designs}
        />

        <Redirect to="/not-found" />
      </Switch>
    </Page>
  );
};
